$(window).on('load', function () {
	// Category Tabs Carousel Script
	var categoryTabsCarousel = $('.categories-tab-container:visible .owl-carousel');
	categoryTabsCarousel.on('initialized.owl.carousel', function () {
		setTimeout(function () {
			var selectedItemIndex = categoryTabsCarousel.find('.owl-item:not(.active) .item a.selectedCategory')
				.parents('.owl-item').index();
			if ($(window).width() > 991) {
				categoryTabsCarousel.trigger('to.owl.carousel', selectedItemIndex - 1);
			} else {
				categoryTabsCarousel.trigger('to.owl.carousel', selectedItemIndex);
			}
			$(".owl-next")
				.html(`<img class="owl-carouselArrowsRight" height="16" width="16" alt="carouselRightArrow"
				src="${ACC.config.commonResourcePath}/images/acima-icons/Nav-arrow-right-orange.svg"/>`);
			$(".owl-prev")
				.html(`<img class="owl-carouselArrowsLeft" height="16" width="16" alt="carouselLeftArrow" 
				src="${ACC.config.commonResourcePath}/images/acima-icons/Nav-arrow-left-orange.svg"/>`);
		}, 100);
	});
	categoryTabsCarousel.owlCarousel({
		margin: 8,
		loop: false,
		autoWidth: true,
		nav: true,
		mouseDrag: true,
		touchDrag: true,
		dots: false,
		itemDesktop: {
			nav: true
		}
	});
	if ($("#searchListPage").length) {
		var resultEvent = 'zeroSearchResultsLoad';
		if ($("#hasSearchResults").length > 0) {
			resultEvent = 'searchResultsLoad';
		}
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': resultEvent
		});
	}
});

$(function () {
	var slectedPriceRangeMin = $("#slectedPriceRangeMin").val();
	var slectedPriceRangeMax = $("#slectedPriceRangeMax").val();
	var priceRangeStartValue = $("#priceRangeStartValue").val();
	var priceRangeEndValue = $("#priceRangeEndValue").val();
	var externalAPIVendor = $("#externalAPIVendor").val();

	if (slectedPriceRangeMin != undefined && slectedPriceRangeMax != undefined) {
		var minValue = parseInt(slectedPriceRangeMin);
		var maxValue = parseInt(slectedPriceRangeMax);
		var maxValueRange = parseInt(priceRangeStartValue);
		var minValueRange = parseInt(priceRangeEndValue);
		$("#priceMinStart").val(parseInt(priceRangeStartValue));
		$("#priceMaxStart").val(parseInt(priceRangeEndValue));
		$("#slider-range").slider({
			range: true,
			min: minValueRange,
			max: maxValueRange,
			values: [minValue, maxValue],
			slide: function (event, ui) {
				$("#amountmin").val(ui.values[0]);
				$("#amountmax").val(ui.values[1]);
				$('.ui-slider-handle:eq(0)').html('<p class="rangeTooltip price-range-min">$' + ui.values[0] + '</p>');
				$('.ui-slider-handle:eq(1)').html('<p class="rangeTooltip price-range-max">$' + ui.values[1] + '</p>');
				$('.price-range-both').html('$' + ui.values[0] + ' - $' + ui.values[1]);
				$(".sort-filter-sticky-bar").removeClass('d-none');
				$('#resetAndSubmitDiv').css('display', 'block');
				$('#SortFilterSubmitBtn').css('display', 'block');
				$('#resetFilter').css('display', 'block');
				resetPriceHandlePositions();
			}
		});

		$("#amountmin").val($("#slider-range").slider("values", 0));
		$("#amountmax").val($("#slider-range").slider("values", 1));
		$('.ui-slider-handle:eq(0)').append('<p class="rangeTooltip price-range-min">$' + $("#slider-range").slider("values", 0) + '</p>');
		$('.ui-slider-handle:eq(1)').append('<p class="rangeTooltip price-range-max">$' + $("#slider-range").slider("values", 1) + '</p>');
		$('.ui-slider-range').append('<span class="price-range-both rangeTooltip ml-5">$' + $('#slider-range').slider('values', 0) + ' - $' + $('#slider-range').slider('values', 1) + '</span>');
	}
	if (externalAPIVendor != 'true') {
		$('#SortAndFilterModal').on('shown.bs.modal', function () {
			resetPriceHandlePositions();
		})
	}

	function resetPriceHandlePositions() {
		if (collisionRangeValues($('.price-range-min:visible'), $('.price-range-max:visible')) == true) {
			$('.price-range-min, .price-range-max').css('opacity', '0');
			$('.price-range-both').css('display', 'block');
		} else {
			$('.price-range-min, .price-range-max').css('opacity', '1');
			$('.price-range-both').css('display', 'none');
		}
	}

	function collisionRangeValues($div1, $div2) {
		var x1 = $div1.offset();
		var x2 = $div2.offset();
		var x11 = 0;
		var x22 = 0;
		if(!isNullUndefined(x1) && !isNullUndefined(x2)) {
			x11 = x1.left;
			x22 = x2.left;
		}
		var w1 = 40;
		var r1 = x11 + w1;
		var w2 = 40;
		var r2 = x22 + w2;
		if (r1 < x22 || x11 > r2) return false;
		return true;
	}

	$('#amountmin').on('input', function () {
		$("#slider-range").slider("values", 0, $(this).val());
		$('.ui-slider-handle:eq(0)').html('<p class="rangeTooltip price-range-min">$' + $("#amountmin").val() + '</p>');
		$('.price-range-both').html('$' + $("#amountmin").val() + ' - $' + $("#amountmax").val());
		resetPriceHandlePositions();
		$('#resetAndSubmitDiv').css('display', 'block');
		$('#SortFilterSubmitBtn').css('display', 'block');
		$('#resetFilter').css('display', 'block');
	})
	$('#amountmax').on('input', function () {
		$("#slider-range").slider("values", 1, $(this).val());
		$('.ui-slider-handle:eq(1)').html('<p class="rangeTooltip price-range-max">$' + $("#amountmax").val() + '</p>');
		$('.price-range-both').html('$' + $("#amountmin").val() + ' - $' + $("#amountmax").val());
		resetPriceHandlePositions();
		$('#resetAndSubmitDiv').css('display', 'block');
		$('#SortFilterSubmitBtn').css('display', 'block');
		$('#resetFilter').css('display', 'block');
	})
});


$('.category_btn').on('click', function () {
	if ($('.facet__list__checkbox').filter(':checked').length > 0) {
		$(".sort-filter-sticky-bar").removeClass('d-none');
		$('#resetAndSubmitDiv').css('display', 'block');
		$('#SortFilterSubmitBtn').css('display', 'block');
		$('#resetFilter').css('display', 'block');
	} else {
		if (!$('#resetFilter').is(':visible')) {
			$(".sort-filter-sticky-bar").addClass('d-none');
		}
	}
});

$('#SortFilterSubmitBtn').on('click', function () {
	callToBackend();
})

$('#paginationAcima li a').on('click', function (e) {
	e.preventDefault();
	var a_href = $(this).attr("href");
	var url = window.location.href;
	if (url != undefined && (url.includes('page') || url.includes('priceValue')) && a_href != undefined) {
		var myString = a_href.substr(a_href.indexOf("page=") + 5);
		url = url.substring(0, url.indexOf('page='));
		url = url + 'page=' + myString;
		location.href = url;
	} else {
		location.href = a_href;
	}
})


$('#resetFilter').on('click', function () {
	$("input:checkbox:checked").map(function () {
		$(this).prop('checked', false);
	});
	var url = window.location;
	var searchTerm = $("#searchResultTerm").val();
	if (searchTerm != undefined) {
		location.href = url.origin + url.pathname + '?text=' + searchTerm;
	} else {
		location.href = url.origin + url.pathname;
	}
})

$(".sortByContainer input:radio").change(function () {
	callToBackend();
});

function callToBackendAmazon(itemClassOrVal, itemParentClassName) {
	$('.full-page-spinner').removeClass('d-none');
	var inputType = $(`.${itemClassOrVal}`);
	var searchFiltersItems = [];

	if (itemParentClassName !== 'category-Applied-Filter') {

		if ($(inputType).attr("name") !== 'All') {
			if (!$(`.${itemClassOrVal}`).is(":checked")) {
				$(inputType).prop("checked", true)
				searchFiltersItems.push($(inputType).attr("name").trim() + '=' + $(inputType).val());
				$(`.${itemParentClassName} input:checkbox`).map(function () {
					if ($(this).attr("name") !== 'All' && $(this).is(":checked")) {
						searchFiltersItems.push($(this).attr("name").trim() + '=' + $(this).val());
					}
				})
			} else {
				$(inputType).prop("checked", false);
			}
			$(".applied-filter-item-input").map(function () {
				if ($(this).attr("name") !== $(`.${itemClassOrVal}`).attr("name")) {
					searchFiltersItems.push($(this).attr("name").trim() + '=' + $(this).val());
				}
			})
		} else {

			let preSelectedValues = [];
			$(`.${itemParentClassName} .facet__list__checkbox`).map(function () {
				if ($(this).val() !== 'All' && $(this).is(":checked")) {
					preSelectedValues.push($(this).val())
				}
			})

			$(".applied-filter-item-input").map(function () {
				if (!(preSelectedValues.includes($(this).val()))) {
					searchFiltersItems.push($(this).attr("name").trim() + '=' + $(this).val());
				}
			})
		}
	} else if (itemParentClassName === 'category-Applied-Filter') {
		$(".applied-filter-item-input").map(function () {
			if (itemClassOrVal !== $(this).val()) {
				searchFiltersItems.push($(this).attr("name").trim() + '=' + $(this).val());
			}
		})
	}

	var url = window.location;
	pathUrl = url.pathname;
	let newUrl = new URL(window.location.href);
	let textParam = newUrl.searchParams.get('text');
	let itemSelected = searchFiltersItems.length > 0 ? `?q=${encodeURIComponent(searchFiltersItems.toString())}` : '';
	let paramsSelected = !isNullUndefined(textParam) ? `${searchFiltersItems.length > 0 ? '&' : '?'}text=${textParam}` : '';
	let filteredUrl = `${itemSelected}${paramsSelected}`

	var tempUrl = url.origin + pathUrl + filteredUrl;
	location.href = tempUrl;
}

function callToBackend() {
	var searchIDs = [];
	var priceIDs = [];
	var externalAPIVendor = $("#externalAPIVendor").val();
	$("input:checkbox:checked").map(function () {
		if (isTrue(externalAPIVendor)) {
			if ($(this).val() != 'All') {
				searchIDs.push($(this).val());
			}
		} else {
			searchIDs.push('%3A'+$(this).attr("data-facetName")+'%3A'+$(this).val());
		}
	});
	var minValue = $("#amountmin").val();
	var maxValue = $("#amountmax").val();
	var priceRangeStartValue = $("#priceRangeStartValue").val();
	var priceRangeEndValue = $("#priceRangeEndValue").val();
	var princMonthlyRange;
	if (maxValue != priceRangeStartValue || minValue != priceRangeEndValue) {
		var princMonthlyRange = true;
	}
	if (minValue != undefined && maxValue != undefined) {
		if (princMonthlyRange != undefined && princMonthlyRange == true) {
			priceIDs.push('%3Aprice_monthly%3Astarting' + minValue + '%20TO%20' + maxValue + 'ending' +
				'%3ApriceRangeStartValue' + priceRangeEndValue + '%3ApriceRangeEndValue' + priceRangeStartValue +
				'%3AprincMonthlyRange');
		} else {
			priceIDs.push('%3Aprice_monthly%3Astarting' + minValue + '%20TO%20' + maxValue + 'ending' +
				'%3ApriceRangeStartValue' + priceRangeEndValue + '%3ApriceRangeEndValue' + priceRangeStartValue);
		}
	}
	var url = window.location;
	pathurl = url.pathname;
	var pageSelected = 0;
	if ($('#currentPageSelected').val() != undefined) {
		pageSelected = $('#currentPageSelected').val();
	}
	var searchResultTerm = $('#searchResultTerm').val();
	if (externalAPIVendor == 'true') {
		if ($('#searchListPage').val() != undefined && $('#searchListPage').val() == 'true') {
			queryParam = `?q=${searchResultTerm}%3A${searchIDs}&page=${pageSelected}`;
		} else {
			queryParam = `${searchIDs}&page=${pageSelected}`;
		}
		var serachUrl = url.origin + pathurl + '?q=' + encodeURIComponent(queryParam);
	} else {
		if ($('#searchListPage').val() != undefined && $('#searchListPage').val() == 'true') {
			queryParam =
				`?q=${searchResultTerm}%3A${$("input[type='radio']:checked").val()}${searchIDs.toString().replaceAll(',', '')}${priceIDs.toString().replaceAll(',', '')}&page=${pageSelected}`;
		} else {
			queryParam =
				`?q=%3A${$("input[type='radio']:checked").val()}${searchIDs.toString().replaceAll(',', '')}${priceIDs.toString().replaceAll(',', '')}&page=${pageSelected}`;
		}
		var serachUrl = url.origin + pathurl + queryParam;
	}
	location.href = serachUrl;
}


$(document).ready(function () {
	$('.loadMoreError').hide();
	if (isMobileDevice()) {
		$("#SortAndFilterModal .modal-dialog").css('height', window.innerHeight);
	}
	updateSortandFilter();
	$('#SortAndFilterModal').on('shown.bs.modal', function () {
		$('#SortAndFilterModal').addClass('open');
		$('body').css('padding-right', 0);
		$('.hide-sortfilter').show();
		window.scrollTo({ top: 0, behavior: 'smooth' });
		if (isElemExist('.ie-div-position-customer-chat')) {
			$('.ie-div-position-customer-chat').hide();
		}
	});
	if ($(".category-Applied-Filter> .applied-Filter-Item").children().length > 0) {
		$('#SortAndFilterModal').modal('show');
		let hideLiveChatTimeout = setInterval(hideLiveChat, 1000);

		function hideLiveChat() {
			if (isElemExist('.ie-div-position-customer-chat')) {
				$('.ie-div-position-customer-chat').hide();
				clearInterval(hideLiveChatTimeout);
			}
		}
	}
	function updateSortandFilter() {
		if ($(window).width() > 1023) {
    		let headerBottomOffset = $('.header-bottom').offset().top; // Offset of the header-bottom div from the top of the document
			$('#SortAndFilterModal').css({
				'top': (headerBottomOffset) + 'px',
				'height': 'calc(100vh - ' + (headerBottomOffset) + 'px)'
			});

		} else {
			$('#SortAndFilterModal').css({
				'top': 0 + 'px',
				'height': 'auto'
			});
		}
	}
	setTimeout(function () {
		if ($(window).width() < 600 && isElemExist('.ie-div-position-customer-chat')) {
			$('.ie-div-position-customer-chat').hide();
		}
	}, 5000);
	$(window).on('resize', function () {
		if ($(window).width() < 600 && isElemExist('.ie-div-position-customer-chat')) {
			$('.ie-div-position-customer-chat').hide();
		}
		else {
			$('.ie-div-position-customer-chat').show();
		}
		updateSortandFilter();
	});
	$('#SortAndFilterModal .back-arow-btn, .hide-sortfilter').on('click', function () {
		$('#SortAndFilterModal').removeClass('open');
		$('.hide-sortfilter').hide();
		if (isMobileDevice()) {
			setTimeout(function () {
				$('#SortAndFilterModal').modal('hide');
			}, 150);
		} else {
			setTimeout(function () {
				$('#SortAndFilterModal').modal('hide');
			}, 250);
		}
	});
});


function loadMoreProducts(isApiFailed) {
	var pageNumberSpan = $("#pageNumber").html();
	var pageNumber = parseInt(pageNumberSpan);
	var numberOfPages = parseInt($("#numberOfPages").html());
	if (pageNumber < numberOfPages) {
		if (isApiFailed == 'false') {
			pageNumber = pageNumber + 1;
		}
		$.ajax({
			url: window.location.pathname + window.location.search,
			data: { showMore: true, page: pageNumber, apiFailure: isApiFailed },
			type: 'GET',
			beforeSend: () => {
				$(".load-more-btn-plp-spinner").removeClass('hide');
				$("#loadMoreBtn").addClass("hide");
			},
			success: (data) => {
				// Hide the Show More button if data is null or data doesnt have any products or if pageNumber is equal to total number of pages
				if (isNullUndefined(data) || data.indexOf("<li") === -1) {
					$('.loadMoreError').show();
				} else if (data.indexOf("<html") > 0) {
					location.reload();
				} else {
					// Append the result to the existing product list
					$('#pageNumber').remove();
					$(".product__listing.product__list").append(data);
					$('.loadMoreError').hide();
				}
			},
			complete: () => {
				$(".load-more-btn-plp-spinner").addClass('hide');
				$("#loadMoreBtn").removeClass("hide")
				if (pageNumber === numberOfPages) {
					$('#loadMoreBtn').hide();
				}
			}
		});
	} else {
		$('.loadMoreError').show();
	}
}